.toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  cursor: pointer;
  outline: none;

  &:focus-visible {
    outline: var(--border-size-md) solid var(--color-brand-primary-main);
    outline-offset: var(--spacing-2xs);
    border-radius: var(--radius-size-sm);
  }

  &--disabled {
    pointer-events: none;

    .toggle__switch {
      background-color: var(--color-neutral-neutral-lightest);
      border-color: var(--border-color-secondary);
    }

    .toggle__input:checked + .toggle__switch {
      background-color: var(--color-brand-primary-lighter);
    }

    .toggle__label {
      color: var(--text-color-tertiary);
    }
  }

  &__input {
    position: absolute;
    opacity: 0;

    @include size(0);

    margin: 0;
  }

  &__switch {
    position: relative;
    display: inline-block;

    @include size(40px, 24px);

    background-color: var(--color-neutral-neutral-lighter);
    border-radius: var(--radius-size-lg);
    transition: all 0.2s ease-in-out;

    &::after {
      content: '';
      position: absolute;
      top: var(--spacing-2xs);
      left: var(--spacing-2xs);

      @include size(16px);

      background-color: var(--background-color-primary);
      border-radius: 50%;
      transition: transform 0.2s ease-in-out;
    }
  }

  &__input:checked + &__switch {
    background-color: var(--color-brand-primary-main);

    &::after {
      transform: translateX(16px);
    }
  }

  &__input:checked:hover + &__switch {
    background-color: var(--action-color-brand-primary-hover);
  }

  &__input:focus-visible + &__switch {
    box-shadow:
      0 0 0 var(--border-size-md) var(--color-neutral-white),
      0 0 0 var(--border-size-lg) var(--color-brand-primary-light);
    outline: none;
  }

  &:hover &__switch {
    background-color: var(--color-neutral-neutral-light);
  }

  &__label {
    color: var(--text-color-primary);
    user-select: none;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, md);
  }
}
